export const StripeWalletName = {
  APPLE_PAY: 'applePay',
  GOOGLE_PAY: 'googlePay',
  BROWSER_CARD: 'browserCard',
};
